var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 427,
    viewBox: "0 0 330 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_761_2021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 330,
    height: 427
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.774 0L0 74V187C0 250 42.5 371 163.774 427C295 373.5 330 251.5 330 187V66L163.774 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_761_2021)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 214,
    r: 60,
    stroke: "#5856D6",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 214,
    r: 40,
    stroke: "#5856D6",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 214,
    r: 80,
    stroke: "#5856D6",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 214,
    r: 100,
    stroke: "#5856D6",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 214,
    r: 120,
    stroke: "#5856D6",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 214,
    r: 143,
    stroke: "#5856D6",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 214,
    r: 172,
    stroke: "#5856D6",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 214,
    r: 204,
    stroke: "#5856D6",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 264,
    width: 61,
    height: 201,
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.9653d8cd084c302219e7eb4ad9b087da.svg";
export { ForwardRef as ReactComponent };